import {
  Show,
  SimpleShowLayout,
  TextField,
  DateField,
  ArrayField,
  Datagrid,
  FunctionField,
  useNotify,
  BooleanField,
  Labeled,
} from "react-admin";
import { Grid, Typography, useMediaQuery } from "@mui/material";
import { getFile } from "server/components/DownloadFile";
import { settings } from "app";
import BackButtonToolbar from "features/BackButtonToolbar";
import { SectionTitle } from "features/SectionTitle";

const ShowDeclarations = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const notify = useNotify();

  return (
    <Show
      title="Детайли за декларация"
      actions={<BackButtonToolbar />}
    >
      <SimpleShowLayout>
        <SectionTitle
          title="Информация"
          textAlign="center"
          sx={{ marginTop: "2rem" }}
        />

        <Grid
          container
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
          spacing={2}
        >
          {/* Text Fields Section */}
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Име на български език">
              <TextField source="nameBg" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Име на английски език">
              <TextField source="nameEn" />
            </Labeled>
          </Grid>
        </Grid>
      </SimpleShowLayout>

      <SimpleShowLayout>
        <SectionTitle
          title="Документи"
          textAlign="center"
          sx={{ marginTop: "2rem" }}
        />
        <Grid
          container
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
            item
            xs={12}
            md={12}
          >
            <ArrayField
              source="declarationDocuments"
              label=""
            >
              <Datagrid
                rowClick={false}
                className="centered-ths"
                bulkActionButtons={false}
                sx={settings.style.secondaryDatagrid}
              >
                <DateField
                  sortable={false}
                  textAlign="center"
                  label="Валидна от"
                  source="validFrom"
                  locales="bg-BG"
                />
                <FunctionField
                  sortable={false}
                  textAlign="center"
                  label="Свали документ на български език"
                  render={record => (
                    <Typography
                      sx={{ display: "inline", textDecoration: "underline", fontSize: "14px", cursor: "pointer" }}
                      onClick={() => getFile(record.bgDocumentId, notify)}
                    >{`file-bg.pdf`}</Typography>
                  )}
                />
                <FunctionField
                  sortable={false}
                  textAlign="center"
                  label="Свали документ на български език"
                  render={record => (
                    <Typography
                      sx={{ display: "inline", textDecoration: "underline", fontSize: "14px", cursor: "pointer" }}
                      onClick={() => getFile(record.enDocumentId, notify)}
                    >{`file-en.pdf`}</Typography>
                  )}
                />
                <BooleanField
                  label="Текущи"
                  textAlign="center"
                  source="isCurrent"
                  FalseIcon={null}
                />
              </Datagrid>
            </ArrayField>
          </Grid>
        </Grid>
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowDeclarations;
